module.exports = __webpack_public_path__ + "img/undo.44ff6126.svg";